import React, { useEffect, useState } from 'react';
import Layout from '../../Layout';
import BreadcrumbBlock from '../../components/BreadcrumbBlock/BreadcrumbBlock';
import { Link, useNavigate } from 'react-router-dom';
import './VIPCustomerCare.scss'
import { Button, ConfigProvider, DatePicker, Input, Pagination, Select, Table, TableColumnsType, Tag, Tooltip } from 'antd';
import { DownloadOutlined, EyeOutlined, SearchOutlined, SettingOutlined } from '@ant-design/icons';
import viVN from 'antd/locale/vi_VN';
import useDebounce from '../../hook/useDebounce';
import { getListReportCustomer, IReportFilter } from '../../api/reportCustomer/reportCustomerApi';
import useToast from '../../hook/useToast';
import * as reportCustomerApi from "../../api/reportCustomer/reportCustomerApi"
import * as selectOptionsApi from "../../api/selectOptions/selectOptionsApi"
import { dataPagination, exportExcel, fommatSelectOption, fommatSelectOptionCreator, fommatSelectOptionUnitByUser, formatDateToDMY } from '../../until';
import { PaginationProps } from 'antd/es/pagination/Pagination';
import useLoading from '../../hook/useLoading';
import useThrottle from '../../hook/useThrottle';
import { LIMIT_EXPORT_EXCEL } from '../../env';
import { TableGroupCustomer } from './TableGroupCustomer';
import { useSelector } from 'react-redux';
import { selectorInfoUser } from '../../store/slices/infoUserSlice';
import { IPermissionMenu } from '../../api/customer/customerApi';
import { selectorUnitByUserPermission } from '../../store/slices/UnitByUserPermission';
import { getCLStaff, IStaff } from '../../api/selectOption/selectOptionsApi';
import { formatNumber } from '../../services/mixin';

const { RangePicker } = DatePicker;
interface DataType {
  key: React.Key;
  code: string;
  name: string;
  unit: string;
  status: number;
  careCounted: number;
  careStaff: string;
  nameGroup: string
  permissionMenu: IPermissionMenu
}


const VIPCustomerCare: React.FC = () => {
  const columns: TableColumnsType<DataType> = [
    {
      title: 'Hành động',
      dataIndex: '',
      key: 'action',
      render: (record: DataType) =>
        <Button
          className="rs-button rs-button--icon-only"
          onClick={() => navigate(`/customer/list/${record.key}`, { state: { isCareFeedback: true, groupPermissionId: record.permissionMenu?.groupPermissionId } })}
          disabled={record.permissionMenu
            ? !record.permissionMenu.view &&
            !record.permissionMenu.edit &&
            !record.permissionMenu.delete
            : true}
        >
          <EyeOutlined />
        </Button>,
    },
    {
      title: 'Mã khách hàng',
      dataIndex: 'code',
      key: 'code',
    },
    {
      title: 'Họ và Tên',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Đơn vị',
      dataIndex: 'unit',
      key: 'unit',
      sorter: true,
    },
    {
      title: 'Trạng thái',
      dataIndex: 'status',
      key: 'status',
      render: (status) => (
        status === 0
          ? <Tag className='rs-tag dust-red'>Chưa chăm sóc</Tag>
          : <Tag className='rs-tag daybreak-blue'>Đã chăm sóc</Tag>
      ),
      sorter: true,
    },
    {
      title: 'Lần chăm sóc trong tháng',
      dataIndex: 'careCounted',
      key: 'careCounted',
      sorter: true,
    },
    {
      title: 'Nhân viên chăm sóc',
      dataIndex: 'careStaff',
      key: 'careStaff',
      sorter: true,
      render: (careStaff) => (
        <Tooltip title={careStaff} >
          <span className='tooltip-an'>{careStaff}</span>
        </Tooltip>

      ),
    },
    {
      title: 'Tên nhóm',
      dataIndex: 'nameGroup',
      key: 'nameGroup',
      sorter: true,
      render: (nameGroup) => (
        <Tooltip title={nameGroup} >
          <span className='tooltip-an'>{nameGroup}</span>
        </Tooltip>

      ),
    },
  ];

  const pushToast = useToast()
  const pushLoading = useLoading()
  const navigate = useNavigate()
  const unitByUserPermissionSlice = useSelector(selectorUnitByUserPermission)
  const { unitTemp } = useSelector(selectorInfoUser)

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([])

  const [sLGroup, setSLGroup] = useState<selectOptionsApi.IGroup[]>([])
  const [listReportCustomer, setListReportCustomer] = useState<DataType[]>([])
  const [infoReportCustomer, setInfoReportCustomer] = useState<reportCustomerApi.GroupCustomer>()
  const [defaulFilter, setDefaultFilter] = useState<IReportFilter>()
  const [sLStaff, setSLStaff] = useState<IStaff[]>([])

  const [pagination, setPagination] = useState({ current: 1, pageSize: 15, total: 0 });

  const gListReportCustomer = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    pushLoading(true)
    const dateStart = defaulFilter?.date ? formatDateToDMY(defaulFilter?.date[0]) : undefined
    const dateEnd = defaulFilter?.date ? formatDateToDMY(defaulFilter?.date[1]) : undefined

    const result = await getListReportCustomer(defaulFilter?.idgroupCustomer, defaulFilter?.search, pageSize, pageCurent, dateStart, dateEnd, unitTemp ?? undefined, defaulFilter?.unitId, defaulFilter?.adminId)
    if (result?.status) {

      setInfoReportCustomer(result?.data.listGroupCustomer)
      setListReportCustomer(convertData(result?.data.listCustomer.list, pageCurent, pageSize))
      setPagination({ current: pageCurent, pageSize, total: result?.data.listCustomer.total })
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }, 1000)


  const convertData = (data: reportCustomerApi.List[], pageCurent: number, pageSize: number) => {

    const convertData = data.map((item) => ({
      key: item.id,
      code: item.code,
      name: item.name,
      unit: item.unitTitle,
      status: item.totalCare,
      careCounted: item.totalCare,
      careStaff: item.nameCare,
      nameGroup: item.groupTitle,
      permissionMenu: item.permissionMenu
    }))
    return convertData
  }

  const gSLStaff = async () => {
    const result = await getCLStaff()
    if (result?.status) {
      setSLStaff(result.data)
    } else {
      pushToast(result?.message, "warning")
    }
  }

  const gSLGroup = async () => {
    const result = await selectOptionsApi.getListGroup()
    if (result?.status) {
      setSLGroup(result.data)
    } else {
      pushToast(result?.message, "warning")
    }
  }


  const onDateChange = (date: any, dateString: string[], info: any) => {
    const isNotEmpty = dateString.some(item => item !== "");
    if (isNotEmpty) {
      setDefaultFilter({ ...defaulFilter, date: dateString })
    } else {
      setDefaultFilter({ ...defaulFilter, date: ["", ""] })
    }
  }

  const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    gListReportCustomer(pageNumber, pageSize)
  }

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const glistByExcel = useThrottle(async () => {
    const result = await getListReportCustomer(defaulFilter?.idgroupCustomer, defaulFilter?.search, LIMIT_EXPORT_EXCEL, 1)
    if (result?.status) {
      formattedDataExcel(result.data.listCustomer.list, result?.message)
    } else {
      pushToast(result?.message, "warning")
    }
  }, 1000)
  // exel được chọn
  const glistSelectedExel = () => {
    const selectedData = listReportCustomer.filter((item) => selectedRowKeys.includes(item.key))
    formattedDataSelectedExcel(selectedData)
  }
  const glistReportExell = async () => {
    const result = await getListReportCustomer(defaulFilter?.idgroupCustomer, defaulFilter?.search, LIMIT_EXPORT_EXCEL, 1)
    if (result?.status) {
      formattedDataReportExcel(result.data.listGroupCustomer.list, "Danh sách báo cáo nhóm khách hàng")
    } else {
      pushToast(result?.message, "warning")
    }
  }
  const formattedDataReportExcel = (data: reportCustomerApi.ListGroupCustomer[], message?: string) => {
    const formattedData = data.map((item) => {
      return {
        "Tên nhóm": item.title,
        "Số khách hàng": item.totalCustomersInGroup,
        "Khách đã chăm sóc": item.totalCaredCustomersInGroup,
        "Khách hàng chưa chăm sóc": item.totalUncaredCustomersInGroup,
        "Tổng số lần chăm sóc": item.totalCareVisitsInGroup,
        "Tỉ lệ chăm sóc": item.carePercentageInGroup,
      }
    }
    );
    exportExcel(formattedData, message)
  }
  const formattedDataExcel = (data: reportCustomerApi.List[], message?: string) => {
    const formattedData = data.map((item) => {
      return {
        "Mã khách hàng": item.code,
        "Họ và tên": item.name,
        "Đơn vị": item.unitTitle,
        "Trạng thái": item.totalCare > 0 ? "Đã chăm sóc" : "Chưa chăm sóc",
        "Lần chăm sóc trong tháng": item.totalCare,
        "Nhân viên chăm sóc": item.nameCare,
      }
    }
    );
    exportExcel(formattedData, message)
  }

  const formattedDataSelectedExcel = (data: DataType[],) => {
    const formattedDataSelected = data.map((item) => {
      return {
        "Mã khách hàng": item.code,
        "Họ và tên": item.name,
        "Đơn vị": item.unit,
        "Trạng thái": item.status > 0 ? "Đã chăm sóc" : "Chưa chăm sóc",
        "Lần chăm sóc trong tháng": item.careCounted,
        "Nhân viên chăm sóc": item.careStaff,
      }
    }
    );
    exportExcel(formattedDataSelected, "Danh sách Khách hàng được chọn")
  }

  const hadleTogleGroupCus = (id: number) => {
    const selected = defaulFilter?.idgroupCustomer || []

    const updateSelected = selected.includes(id) ? selected.filter((item) => item !== id) : [...selected, id]
    setDefaultFilter({ ...defaulFilter, idgroupCustomer: updateSelected })
  }
  useEffect(() => {
    gListReportCustomer()

  }, [defaulFilter, unitTemp])

  useEffect(() => {
    document.title = 'THACO AUTO CRM';

    gSLGroup()
    gSLStaff()
  }, []);

  return (
    <Layout contentClassName='vip-care-content'>
      <BreadcrumbBlock
        items={[
          { title: <Link to="/">THACO AUTO CRM</Link>, },
          { title: 'Báo cáo phân tích', },
          { title: 'Chăm sóc khách hàng ', },
        ]}
        title='Chăm sóc khách hàng '
      />
      <div className="vip-care-report">
        <div className="top">
          <span className="font-medium fsz-16 lh-24">Báo cáo hoạt động CSKH</span>
          <div className="control">
            <div className='w-256-px'>
              <Select
                allowClear
                mode='multiple'
                placeholder="Nhóm khách hàng"
                options={fommatSelectOption(sLGroup)}
                value={defaulFilter?.idgroupCustomer}
                onChange={(e: number[]) => setDefaultFilter({ ...defaulFilter, idgroupCustomer: e })}
                className="custom-select-mutiple-v2"

                popupMatchSelectWidth={false}

              />
            </div>
            <RangePicker
              className="rs-range-picker"
              popupClassName="rs-range-picker-dropdown"
              placeholder={["Từ ngày", "Đến ngày"]}
              format={["DD/MM/YYYY", "DD/MM/YYYY"]}
              onCalendarChange={onDateChange}
            />
          </div>
        </div>


        <div className='bg-card border-E0F2FC rounded-8-px  w-full pt-6 px-6 d-flex flex-column gap-18-px '>
          <div className='d-flex justify-between'>
            <span className='text-base font-medium fw-500 text-344054'>Nhóm khách hàng</span>
            <button
              className='border-none bg-white rounded-6-px w-138-px py-2 h-8 d-flex justify-center align-center gap-10-px '
              onClick={glistReportExell}
            >
              <DownloadOutlined className='text-sm text-344054' />
              <span className='text-sm fw-400 font-regular text-344054 white-space-nowrap'>Xuất báo cáo</span>
            </button>
          </div>
          <TableGroupCustomer
            infoReportCustomer={infoReportCustomer}
            defaulFilter={defaulFilter}

            hadleTogleGroupCus={hadleTogleGroupCus}
          />
        </div>
      </div>
      <div className="vip-care-report-table custom-page-css flex-1">
        <div className="top">
          <div className='d-flex gap-3'>
            <div className="w-600-px border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center pl-3  py-1 h-8 justify-between overflow-hidden">
              <Input
                placeholder="Tìm lượt chăm sóc khách theo mã khách hàng, số điện thoại, hoặc email"
                className="bg-FCFCFD text-sm border-none custom-input-focus none-focus-erro font-regular p-none-input place-holder-input-667085 hover-none"
                value={defaulFilter?.search}
                onChange={(e) => setDefaultFilter({ ...defaulFilter, search: e.target.value })}
              />
              <div className=" border-l-F2F4F7 h-full d-flex align-center">
                <SearchOutlined className="text-sm text-98A2B3 px-9-px" />
              </div>
            </div>
            <div className='w-169-px'>
              <Select
                placeholder="Đơn vị"
                options={fommatSelectOptionUnitByUser(unitByUserPermissionSlice)}
                className="custome-select rs-select"

                allowClear
                showSearch
                onClear={() => setDefaultFilter({ ...defaulFilter, unitId: undefined })}
                value={defaulFilter?.unitId}
                onChange={(e) => setDefaultFilter({ ...defaulFilter, unitId: e !== undefined ? Number(e) : undefined })}
              />
            </div>

            <div className='w-169-px'>
              <Select
                placeholder="Nhân viên chăm sóc"
                options={fommatSelectOptionCreator(sLStaff)}
                className="custome-select rs-select"

                allowClear
                onClear={() => setDefaultFilter({ ...defaulFilter, adminId: undefined })}
                value={defaulFilter?.adminId}
                onChange={(e) => setDefaultFilter({ ...defaulFilter, adminId: e !== undefined ? Number(e) : undefined })}
              />
            </div>
          </div>

          <div className="control">
            {/* <Button className="rs-button" >
              <DownloadOutlined />
              <span>Nhập DS</span>
            </Button> */}
            <Button className="rs-button" onClick={selectedRowKeys.length ? glistSelectedExel : glistByExcel}>
              <DownloadOutlined />
              <span>Xuất DS</span>
            </Button>

            <Button className="rs-button">
              <SettingOutlined />
            </Button>
          </div>
        </div>

        <div className=" t-table-customer custom-page-css flex flex-col flex-1 justify-between">
          <Table
            className='rs-table'
            rowClassName={(record, index) => index % 2 === 0 ? 'table-row-dark' : 'table-row-light'}
            rowSelection={rowSelection}
            columns={columns}
            dataSource={listReportCustomer}
            pagination={false}
            showSorterTooltip={false}
            scroll={{ x: true }}
          />
          <ConfigProvider locale={viVN}>
            <div className="pagination-block">
              <Pagination
                showSizeChanger
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={pagination.total}
                itemRender={(page, type, originalElement) => {
                  // Chỉ custom khi là nút số trang
                  if (type === 'page') {
                    return <span>{formatNumber(page)}</span>;
                  }
                  // prev / next / jump-prev / jump-next giữ nguyên
                  return originalElement;
                }}
                showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, pagination.current).totalPage} trang`}
                className='rs-pagination'
                onChange={onPaginationChange}

              />
            </div>
          </ConfigProvider>
        </div>
      </div>
    </Layout>
  );
}

export default VIPCustomerCare;
